import { FC, ReactElement } from 'react';
import { Box } from '@mui/material';

import markAnyGrayLogo from '@assets/images/markAnyGrayLogo.svg';

const AuthFooter: FC = (): ReactElement => {
  return (
    <footer>
      <Box
        display="flex"
        justifyContent="center"
        paddingTop="16px"
        paddingBottom="20px"
        height="60px"
      >
        <Box>
          <img src={markAnyGrayLogo} alt="MarkAny" width={88} height={24} />
        </Box>
      </Box>
    </footer>
  );
};

export default AuthFooter;
